<template>
  <tr>
    <td class="text-no-wrap">
      <div class="font-weight-medium text-body-1 mb-1">
        {{ $dayjs(data.stats.raw_data.event_at_date).format('MMM DD, YYYY') }} &middot; {{ $dayjs.utc(data.stats.raw_data.event_at_date + data.stats.raw_data.event_start).tz(timezone).format('HH:mm') }}
      </div>
      <div
        class="caption grey--text"
      >
        <strong>
          {{ data.stats.raw_data.event_duration }} min
        </strong>
      </div>
    </td>
    <td>
      <div
        v-if="data.training_protocol"
        class="text-body-1"
      >
        {{ data.training_protocol.name }}
      </div>
      <div
        v-else
        class="grey--text caption"
      >
        {{ $t('status.fieldwiz.unknown') }}
      </div>
      <div class="mt-1">
        <v-chip
          label
          small
          class="mr-1"
        >
          <strong class="mr-1"> {{ getOrdinal(data.stats.raw_data.order) }} </strong> {{ $t("training_builder.exercise.lowercase") }}
        </v-chip>
        <v-chip
          v-if="data.stats.raw_data.superset"
          label
          small
          class="mr-1"
        >
          {{ $t("preposition.in") }}<strong class="mx-1">{{ $t("training_builder.superset.lowercase") }}</strong> <span v-if="data.stats.raw_data.order_in_superset">({{ getOrdinal(data.stats.raw_data.order_in_superset) }})</span>
        </v-chip>
      </div>
    </td>
    <td>
      <exercise-params-view-template
        :sets="data.params.sets"
        has-realizations
        :group-id="trainingExerciseGroupId"
        :params="data.params"
      />
    </td>
  </tr>
</template>

<script>
import { TrainingExerciseGroupId } from '@/data/models/TrainingExercise'
import ExerciseParamsViewTemplate from '@/components/training-builder/ExerciseParamsViewTemplate.vue'
import dayjs from 'dayjs'
import { getOrdinal } from '@/utils/helpers'
import { get } from 'lodash'

export default {
  name: 'PlayerTrainingHistoryTableRow',
  components: {
    ExerciseParamsViewTemplate
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    player: {
      type: Object,
      default: () => ({})
    },
    trainingExerciseGroupId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    timezone: null
  }),
  created() {
    this.groupIds = TrainingExerciseGroupId
    this.timezone = dayjs.tz.guess()
  },
  methods: { get, getOrdinal, dayjs }
}

</script>

<style scoped>

</style>
